module.exports = __webpack_public_path__ + "static/img/android1.3.dcc6353f.jpg";